import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Legal.css';

const TermsPage = () => {
  const lastUpdated = 'July 20, 2025';

  return (
    <Container className="legal-page terms-page">
      <Card className="legal-card">
        <Card.Header className="text-center">
          <h1>Terms and Conditions</h1>
          <p className="text-muted">Last Updated: {lastUpdated}</p>
        </Card.Header>
        <Card.Body>
          <section className="mb-4">
            <h2>1. Introduction</h2>
            <p>
              Welcome to AffSimple.com. These Terms and Conditions govern your use of our website located at
              <span className="url"> https://affsimple.com</span> ("Service") operated by Skjoldan Consulting (CVR: DK21417289), a Danish company.
            </p>
            <p>
              By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms,
              you may not access the Service.
            </p>
          </section>

          <section className="mb-4">
            <h2>2. Accounts</h2>
            <p>
              When you create an account with us, you must provide information that is accurate, complete, and current at all times.
              Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
            </p>
            <p>
              You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.
            </p>
          </section>

          <section className="mb-4">
            <h2>3. Subscription and Payments</h2>
            <p>
              Certain parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance on a recurring basis,
              depending on the type of Subscription plan you select.
            </p>
            <p>
              At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or
              Skjoldan Consulting cancels it. EU consumers have a 14-day cooling-off period to cancel subscriptions without giving any reason.
            </p>
          </section>

          <section className="mb-4">
            <h2>4. Free Trial</h2>
            <p>
              We offer a Free plan with limited features and usage. This plan has no time limitation but is subject to usage restrictions as specified
              in our pricing information.
            </p>
            <p>
              Pro plan subscriptions may include a free trial period. At the end of such trial period, you will be charged according to your selected plan
              unless you cancel before the trial ends.
            </p>
          </section>

          <section className="mb-4">
            <h2>5. Usage Limitations</h2>
            <p>
              Depending on your subscription plan, there may be limitations on the number of clicks, conversions, and other features you can use.
              If you exceed these limitations, you may be required to upgrade your subscription or wait until the next billing cycle.
            </p>
          </section>

          <section className="mb-4">
            <h2>6. Data Privacy</h2>
            <p>
              Our Privacy Policy describes how we handle the information you provide to us when you use our Service.
              You understand that through your use of the Services you consent to the collection and use of this information.
            </p>
          </section>

          <section className="mb-4">
            <h2>7. Intellectual Property</h2>
            <p>
              The Service and its original content (excluding content provided by users), features, and functionality are and will remain the exclusive property
              of Affiliate Tracking SaaS and its licensors.
            </p>
          </section>

          <section className="mb-4">
            <h2>8. Termination</h2>
            <p>
              We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without
              limitation if you breach the Terms.
            </p>
            <p>
              Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue
              using the Service or contact our support team.
            </p>
          </section>

          <section className="mb-4">
            <h2>9. Limitation of Liability</h2>
            <p>
              In no event shall Skjoldan Consulting, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any
              indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill,
              or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
            </p>
            <p>
              These Terms shall be governed by and construed in accordance with Danish law. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the Danish courts.
            </p>
          </section>

          <section className="mb-4">
            <h2>10. Changes</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at
              least 30 days' notice prior to any new terms taking effect.
            </p>
            <p>
              By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not
              agree to the new terms, please stop using the Service.
            </p>
          </section>

          <section className="mb-4">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p>
              <strong>Skjoldan Consulting</strong><br />
              CVR: DK21417289<br />
              Address: Denmark<br />
              Email: <a href="mailto:support@affsimple.com">support@affsimple.com</a><br />
              Website: <a href="https://affsimple.com">https://affsimple.com</a>
            </p>
            <p>
              <strong>VAT Information:</strong> We are registered for VAT in Denmark. VAT will be added to invoices for Danish customers as required by law.
            </p>
            <p>
              For data protection inquiries, you may also contact the Danish Data Protection Authority (Datatilsynet) at <a href="https://www.datatilsynet.dk">www.datatilsynet.dk</a>
            </p>
          </section>
        </Card.Body>
        <Card.Footer className="text-center">
          <Button as={Link} to="/" variant="primary" className="me-2">
            Return to Home
          </Button>
          <Button as={Link} to="/privacy" variant="outline-primary">
            Privacy Policy
          </Button>
        </Card.Footer>
      </Card>
    </Container>
  );
};

export default TermsPage;
